class Ep8BundleSelector extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', this.#handleChange);
    this.addEventListener('click', this.#handleClick);
    this.#syncOptions();
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.#handleChange);
    this.removeEventListener('click', this.#handleClick);
  }

  #handleClick = (event) => {
    const option = event.target.closest('[data-bundle-option]');
    if (!option || event.target.closest('select')) return;

    const radio = option.querySelector('input[type="radio"]');
    if (radio && !radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  #handleChange = (event) => {
    if (event.target.matches('input[type="radio"]')) this.#syncOptions();
  };

  #syncOptions() {
    for (const option of this.querySelectorAll('[data-bundle-option]')) {
      const selected = option.querySelector('input[type="radio"]')?.checked === true;
      option.classList.toggle('is-selected', selected);
      option.querySelector('[data-bundle-choices]')?.toggleAttribute('hidden', !selected);
    }
  }

  getItems() {
    const activeOption = this.querySelector('[data-bundle-option]:has(input[type="radio"]:checked)');
    if (!activeOption) return [];

    const quantities = new Map();
    for (const select of activeOption.querySelectorAll('select')) {
      if (!select.value || select.selectedOptions[0]?.disabled) return [];
      quantities.set(select.value, (quantities.get(select.value) || 0) + 1);
    }

    return Array.from(quantities, ([variantId, quantity]) => ({ variantId, quantity }));
  }
}

if (!customElements.get('ep8-bundle-selector')) {
  customElements.define('ep8-bundle-selector', Ep8BundleSelector);
}
